import React, { ReactNode } from 'react';

import { FormItem } from '../shared/FormItem';
import { Textarea, TextareaProps } from './Textarea';

type TextareaItemProps = {
  label?: string | ReactNode;
  labelClassName?: string;
  required?: boolean;
  error?: string;
} & Omit<TextareaProps, 'hasError'>;

export const TextareaItem = React.forwardRef<
  HTMLTextAreaElement,
  TextareaItemProps
>((props, ref) => {
  const {
    name,
    required,
    error,
    label,
    labelClassName,
    className,
    ...textareaProps
  } = props;

  return (
    <FormItem
      className={className}
      name={name}
      label={label}
      labelClassName={labelClassName}
      required={required}
      error={error}
      dataTestId={`${textareaProps['data-testid']}-wrapper`}
    >
      <Textarea
        ref={ref}
        name={name}
        id={name}
        hasError={!!error}
        {...textareaProps}
      />
    </FormItem>
  );
});

TextareaItem.displayName = 'TextareaItem';
